import React, { createContext, useState, useContext } from "react";

const WaitingOrderContext = createContext();

export const WaitingOrderProvider = ({ children }) => {
  const [isWaitingOrder, setIsWaitingOrder] = useState(
    localStorage.getItem("isWaitingOrder") === "true"
  );

  const [inProgressOrderId, setInProgressOrderId] = useState(
    localStorage.getItem("inProgress_orderId") || null
  );

  // Update isWaitingOrder and sync with localStorage
  const updateIsWaitingOrder = (value) => {
    setIsWaitingOrder(value);
    localStorage.setItem("isWaitingOrder", value.toString());
  };

  // Update inProgress_orderId and sync with localStorage
  const updateInProgressOrderId = (orderId) => {
    setInProgressOrderId(orderId);
    if (orderId) {
      localStorage.setItem("inProgress_orderId", orderId);
    } else {
      localStorage.removeItem("inProgress_orderId");
    }
  };

  return (
    <WaitingOrderContext.Provider
      value={{
        isWaitingOrder,
        updateIsWaitingOrder,
        inProgressOrderId,
        updateInProgressOrderId,
      }}
    >
      {children}
    </WaitingOrderContext.Provider>
  );
};

export const useWaitingOrder = () => useContext(WaitingOrderContext);
